import { IMG_OSS_URL } from '@/constants'
import { onErrorResumeNext } from 'rxjs'
// 根据获得当前 locationId 返回地区
export function getAddress(locationId, second = '') {
  const address_name = 'vuejs__ZHULOGIC_ADDRESS' || 'ZHULOGIC_ADDRESS'
  let lists = JSON.parse(localStorage.getItem(address_name)).value
  let address = ''
  if (!locationId || !lists) {
    return
  }
  lists.forEach((province) => {
    province.cities.forEach((city) => {
      if (second) {
        if (city.id === Number(locationId)) {
          address = province.name + ' ' + city.name
        }
      } else {
        city.cities.forEach((zone) => {
          if (zone.id === Number(locationId)) {
            address = province.name + ' ' + city.name + ' ' + zone.name
          }
        })
      }
    })
  })
  return address
}

// 判断是不是手机打开
export function bowerStyle() {
  if (
    navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    )
  ) {
    return 'phone'
  } else {
    return 'pc'
  }
}

// 下载
export function downloadURI(uri, name) {
  const link = document.createElement('a')
  link.download = name
  link.href = uri
  link.target = '_blank'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

// 判断是否为IE10
export function Below_IE10() {
  let theUA = window.navigator.userAgent.toLowerCase()
  if (
    (theUA.match(/msie\s\d+/) && theUA.match(/msie\s\d+/)[0]) ||
    (theUA.match(/trident\s?\d+/) && theUA.match(/trident\s?\d+/)[0])
  ) {
    var ieVersion =
      theUA.match(/msie\s\d+/)[0].match(/\d+/)[0] ||
      theUA.match(/trident\s?\d+/)[0]
    if (ieVersion < 10) {
      return true
    }
  } else {
    return false
  }
}

// 节流
export function debounce(fn, delay, mustRunDelay) {
  var timer = null
  var t_start
  return function() {
    var context = this,
      args = arguments,
      t_curr = +new Date()
    clearTimeout(timer)
    if (!t_start) {
      t_start = t_curr
    }
    if (t_curr - t_start >= mustRunDelay) {
      fn.apply(context, args)
      t_start = t_curr
    } else {
      timer = setTimeout(function() {
        fn.apply(context, args)
      }, delay)
    }
  }
}

/* 判断数据是否存在并且dom是否应该显示 */
export function according(data, type) {
  if (!data) {
    return false
  }
  let typeStr = Object.prototype.toString.call(data)
  let typeName
  switch (typeStr) {
    case '[object Object]':
      typeName = 'object'
      break
    case '[object Array]':
      typeName = 'array'
      break
  }
  if ((type == typeName) == 'array') {
    if (data.length > 0) {
      return true
    }
  } else if ((type == typeName) == 'object') {
    if (Object.keys(data).length > 0) {
      return true
    }
  }
  return false
}

export function download(sUrl) {
  const isChrome = navigator.userAgent.toLowerCase().indexOf('chrome') > -1
  const isSafari = navigator.userAgent.toLowerCase().indexOf('safari') > -1
  //iOS devices do not support downloading. We have to inform user about this.
  if (/(iP)/g.test(navigator.userAgent)) {
    alert('您的设备不支持文件下载,请在桌面浏览器中再试一次。')
    return false
  }

  //If in Chrome or Safari - download via virtual link click
  if (isChrome || isSafari) {
    //Creating new link node.
    var link = document.createElement('a')
    link.href = sUrl
    link.target = '_blank'

    if (link.download !== undefined) {
      //Set HTML5 download attribute. This will prevent file from opening if supported.
      var fileName = sUrl.substring(sUrl.lastIndexOf('/') + 1, sUrl.length)
      link.download = fileName
    }
    //Dispatching click event.
    if (document.createEvent) {
      var e = document.createEvent('MouseEvents')
      e.initEvent('click', true, true)
      link.dispatchEvent(e)
      return true
    }
  }

  // Force file download (whether supported by server).
  if (sUrl.indexOf('?') === -1) {
    sUrl += '?download'
  }
  window.open(sUrl, '_self')
  return true
}

export function ossFullURL(key) {
  return `${IMG_OSS_URL}/${key}`
}

export function styleBackgroundImage(key) {
  if (!key) return {}

  return {
    'background-image': `url(${ossFullURL(key)})`,
  }
}

/* 随机字符串 */
export function randomString(len) {
  len = len || 34
  var $chars =
    'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678' /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
  var maxPos = $chars.length
  var pwd = ''
  for (let i = 0; i < len; i++) {
    pwd += $chars.charAt(Math.floor(Math.random() * maxPos))
  }
  return pwd
}

/* bsae64 => blob */
export function b64toBlob(base64) {
  var base64Arr = base64.split(',')
  var imgtype = ''
  var base64String = ''
  if (base64Arr.length > 1) {
    //如果是图片base64，去掉头信息
    base64String = base64Arr[1]
    imgtype = base64Arr[0].substring(
      base64Arr[0].indexOf(':') + 1,
      base64Arr[0].indexOf(';')
    )
  }
  // 将base64解码
  var bytes = atob(base64String)
  //var bytes = base64;
  var bytesCode = new ArrayBuffer(bytes.length)
  // 转换为类型化数组
  var byteArray = new Uint8Array(bytesCode)

  // 将base64转换为ascii码
  for (var i = 0; i < bytes.length; i++) {
    byteArray[i] = bytes.charCodeAt(i)
  }

  // 生成Blob对象（文件对象）
  return new Blob([bytesCode], {
    type: imgtype,
  })
}

/* boble对象  oss 直传 fun */
export function ossUpload(data, file, type) {
  // 这个url是要上传时的地址，存在data的host上
  // let url = data.host
  // let name = file.name
  let filenameSuffix = file.type.split('/')[1]

  let key = data.dir + randomString() + '.' + filenameSuffix

  // 新建formData对象，使用append方法添加字段，在data中拿的都是请求回来的参数
  let formData = new FormData()
  formData.append('x:type', type || 10)
  formData.append('x:originname', type || 10)
  formData.append('key', key)
  formData.append('policy', data.policy)
  formData.append('OSSAccessKeyId', data.OSSAccessKeyId)
  formData.append('success_action_status', '200')
  formData.append('callback', data.callback)
  formData.append('signature', data.signature)
  formData.append('file', file) // 文件，选择时存在data上
  return formData
}

/* 深拷贝 */
export function deepClone(data) {
  var type = getType(data)
  var obj
  if (type === 'array') {
    obj = []
  } else if (type === 'object') {
    obj = {}
  } else {
    //不再具有下一层次
    return data
  }
  if (type === 'array') {
    for (var i = 0, len = data.length; i < len; i++) {
      obj.push(deepClone(data[i]))
    }
  } else if (type === 'object') {
    for (var key in data) {
      obj[key] = deepClone(data[key])
    }
  }
  return obj
}

/* 给姓名加* */
export function formatName(name) {
  let newStr
  if (name.length === 2) {
    newStr = name.substr(0, 1) + '*'
  } else if (name.length > 2) {
    let char = ''
    for (let i = 0, len = name.length - 2; i < len; i++) {
      char += '*'
    }
    newStr = name.substr(0, 1) + char + name.substr(-1, 1)
  } else {
    newStr = name
  }

  return newStr
}

/* 给身份证加* */
export function plusXing(str, frontLen, endLen) {
  var len = str.length - frontLen - endLen
  var xing = ''
  for (var i = 0; i < len; i++) {
    xing += '*'
  }
  return str.substring(0, frontLen) + xing + str.substring(str.length - endLen)
}

// 返回顶部
export function backTop() {
  document.body.scrollTop = 0
  document.documentElement.scrollTop = 0
}
